import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Spinner } from 'react-bootstrap';

function ModalCentered(props) {
  const {
    body,
    confirmBtnText,
    header,
    onConfirm,
    disabled = false,
    loadingConfirm = false,
    className,
    ...rest
  } = props;
  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className={`p-3 ${className}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.body}</Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        {disabled ? (
          <Button disabled>{props.confirmBtnText}</Button>
        ) : (
          <Button
            onClick={() =>
              onConfirm
                ? onConfirm()
                : console.log('No confirm function specified')
            }
          >
            {props.confirmBtnText}
            {loadingConfirm && (
              <>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='me-2'
                />
                <span className='visually-hidden'>Loading...</span>
              </>
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCentered;
